"use client";

import styles from "./ThemeSwitcher.module.css";
import { useEffect, useState, useTransition } from "react";
import { useTheme } from "next-themes";
import IconMoon from "@/public/icons/header/icon-moon.svg";
import IconSun from "@/public/icons/header/icon-sun.svg";

export default function ThemeSwitcher() {
  const [mounted, setMounted] = useState(false);
  const [, startTransition] = useTransition();
  const { theme, setTheme } = useTheme();

  const handleThemeChanged = (th: string) => {
    startTransition(() => {
      setTheme(th);
    });
  };

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <div>
      {/* {!theme && (
        <div className={styles.btn} onClick={() => handleThemeChanged("dark")}>
          <IconMoon />
        </div>
      )} */}
      {theme && theme == "light" && (
        <div className={styles.btn} onClick={() => handleThemeChanged("dark")}>
          <IconMoon />
        </div>
      )}
      {theme && theme == "dark" && (
        <div className={styles.btn} onClick={() => handleThemeChanged("light")}>
          <IconSun />
        </div>
      )}
    </div>
  );
}
